import { EstimatedUnbillFigureRepoImpl } from "domain/repository/EstimatedUnbillFigure/EstimatedUnbillFigureRepoImpl";
import { useEstimatedUnbillFigureTracked } from "presentation/store/EstimatedUnbillFigure/EstimatedUnbillFigureProvider";
import { EstimatedUnbillFigureVM } from "presentation/viewModel/EstimatedUnbillFigure/EstimatedUnbillFigureVM";
import { useMemo } from "react";

export const useEstimatedUnbillFigureVM = () => {
    const [, setEstimatedUnbillFigureState] = useEstimatedUnbillFigureTracked();
    const tariffCoaMappingVM = useMemo(() =>
        EstimatedUnbillFigureVM({
            dispatch: [setEstimatedUnbillFigureState],
            repo: EstimatedUnbillFigureRepoImpl(),
        }), [setEstimatedUnbillFigureState])

    return tariffCoaMappingVM
}